import DestinationData from "./DestinationData";
import "./DestinationStyles.css";
import Mountain1 from "../Assets/1.jpg";
import Mountain2 from "../Assets/2.jpg";
import Mountain3 from "../Assets/3.jpg";
import Mountain4 from "../Assets/4.jpg";

const Destination = () => {
  return (
    <div className="destination">
      <h1>Popular Destination</h1>
      <p>Tours give you the opportunity to enjoy the world</p>
      <DestinationData
        className="first-des"
        heading="Sigiriya Fortress  "
        text="Sigiriya is one of Sri Lanka’s most popular tourist attractions – and with good reason. This ruined, fifth century city has some extraordinary features, including moat and wall fortifications, elaborately landscaped gardens, and a monastery. But it is the two-hundred metre high
          granite rock that stands out from these ruins that is undoubtedly the star attraction, with its exquisite frescoes and the remains of a royal palace on the summit."
        img1={"https://images.unsplash.com/photo-1610110167776-b8d05197fae1?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fHNpZ2lyaXlhfGVufDB8fDB8fHww"}
        img2={"https://images.unsplash.com/photo-1588598198321-9735fd52455b?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c2lnaXJpeWF8ZW58MHx8MHx8fDA%3D"}
      />
      <DestinationData
        className="first-des-reverse"
        heading="Little Adams Peak"
        text="Nestled in the heart of Sri Lanka, Adam's Peak, also known as Sri Pada, is a trek that combines natural beauty with 
          spiritual significance. This notable pyramid-shaped mountain is one of the most sacred mountains on the island, standing at an elevation of 2,243 meters (7,359 feet)"
        img1={"https://media.istockphoto.com/id/638591100/photo/little-adams-peak-sri-lanka.webp?b=1&s=170667a&w=0&k=20&c=2RoTZQgllB_-5sb1YJj1NKNvn_YkLaTCkuAq5AwoM3g="}
        img2={"https://media.istockphoto.com/id/1472817881/photo/little-adams-peak.webp?b=1&s=170667a&w=0&k=20&c=6llC0N-ua_TLDEsPyGGie_SKePdchpwqR4PSLYD1pv4="}
      />
      <DestinationData
        className="first-des"
        heading="Galle Fort"
        text="Sigiriya is one of Sri Lanka’s most popular tourist attractions – and with good reason. This ruined, fifth century city has some extraordinary features, including moat and wall fortifications, elaborately landscaped gardens, and a monastery. But it is the two-hundred metre high granite rock that stands out from these ruins that is undoubtedly the star attraction, with its exquisite frescoes and the remains of a royal palace on the summit."
        img1={
          "https://media.istockphoto.com/id/1254219156/photo/sunrise-over-galle-dutch-fort-lighthouse-surrounded-by-coconut-trees-in-sri-lanka.webp?b=1&s=170667a&w=0&k=20&c=Ug1gl_bwdd3bLYxv75XbP0PmSVY6l1Bu1ga-O3KGvD8="
        }
        img2={
          "https://media.istockphoto.com/id/912181808/photo/view-of-lighthouse-dondra-matara-sri-lanka.webp?b=1&s=170667a&w=0&k=20&c=Eeog0ap_hlzMpvtuAl4KcuWhc2ctW3dMQCULDAwBSDc="
        }
      />
       <DestinationData
        className="first-des-reverse"
        heading="Little England Cottage"
        text="The Little England Cottages Gated Community is designed, developed, landscaped, maintained and managed by Jaysons Realty (Pvt) Ltd, a Sri Lankan family owned real estate company authorised by the Sri Lanka Board of Investment (BOI). Jaysons Realty (Pvt) Ltd is part of Jaysons Holdings, a group of Sri Lankan companies with expertise in property management and development, hotels, restaurants, International Investment facilitation (Singapore) and Mineral Sands."
        img1={
          "https://media.istockphoto.com/id/1483804394/photo/a-street-on-a-modern-brick-built-housing-development-in-the-uk.jpg?s=612x612&w=0&k=20&c=f9_SKMXHGnH_PHsKOCLZa4ARtOsXF62VlAE4iJQERZc="
        }
        img2={
          "https://media.istockphoto.com/id/949114642/photo/traditional-london-terraced-houses.webp?b=1&s=170667a&w=0&k=20&c=8rB6UMcXJ84v_xReDAHuSXWBDAjL_p73epjaLeZjjuI="
        }
      />
    </div>
  );
};

export default Destination;
